import React from 'react'
import Assets from 'app/configs/assetConfigs'
import { FormattedMessage } from 'react-intl'
import * as R from 'ramda'
import NotificationBadge from './NotificationBadge'
import { PollTypeIcon } from '../icons'
import { TYPE_EVENT, TYPE_POLL } from 'app/constants/messageType'

const badgePropsForType = R.cond([
  [
    R.equals(TYPE_EVENT),
    R.always({
      variant: 'primary',
      Icon: <img src={Assets.notiTypeInPreview.event} alt="event" />,
      children: <FormattedMessage id="notiType.event.label" />,
    }),
  ],
  [
    R.equals(TYPE_POLL),
    R.always({
      variant: 'primary',
      Icon: <PollTypeIcon fill="#ffffff" className="min-w-14 w-12" />,
      children: <FormattedMessage id="notification.type.poll" />,
    }),
  ],
  [
    R.T,
    R.always({
      variant: 'primary',
      Icon: <img src={Assets.notiTypeInPreview.info} alt="general" />,
      children: <FormattedMessage id="notiType.general.label" />,
    }),
  ],
])

const NotificationTypePreview = ({ type, className }) => {
  return (
    <NotificationBadge
      className={className}
      isTextUpperCase={false}
      type={type}
      {...badgePropsForType(type)}
    />
  )
}

export default NotificationTypePreview
